function CoffeeIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 36 36'
        fill='currentColor'
      >
        <path d='M25.5 12C25.5 11.1716 26.1716 10.5 27 10.5H28.5C30.4891 10.5 32.3968 11.2902 33.8033 12.6967C35.2098 14.1032 36 16.0109 36 18C36 19.9891 35.2098 21.8968 33.8033 23.3033C32.3968 24.7098 30.4891 25.5 28.5 25.5H27C26.1716 25.5 25.5 24.8284 25.5 24C25.5 23.1716 26.1716 22.5 27 22.5H28.5C29.6935 22.5 30.8381 22.0259 31.682 21.182C32.5259 20.3381 33 19.1935 33 18C33 16.8065 32.5259 15.6619 31.682 14.818C30.8381 13.9741 29.6935 13.5 28.5 13.5H27C26.1716 13.5 25.5 12.8284 25.5 12Z' />
        <path d='M1.5 12C1.5 11.1716 2.17157 10.5 3 10.5H27C27.8284 10.5 28.5 11.1716 28.5 12V25.5C28.5 27.4891 27.7098 29.3968 26.3033 30.8033C24.8968 32.2098 22.9891 33 21 33H9C7.01088 33 5.10322 32.2098 3.6967 30.8033C2.29018 29.3968 1.5 27.4891 1.5 25.5V12ZM4.5 13.5V25.5C4.5 26.6935 4.97411 27.8381 5.81802 28.682C6.66193 29.5259 7.80653 30 9 30H21C22.1935 30 23.3381 29.5259 24.182 28.682C25.0259 27.8381 25.5 26.6935 25.5 25.5V13.5H4.5Z' />
        <path d='M9 0C9.82843 0 10.5 0.671573 10.5 1.5V6C10.5 6.82843 9.82843 7.5 9 7.5C8.17157 7.5 7.5 6.82843 7.5 6V1.5C7.5 0.671573 8.17157 0 9 0Z' />
        <path d='M15 0C15.8284 0 16.5 0.671573 16.5 1.5V6C16.5 6.82843 15.8284 7.5 15 7.5C14.1716 7.5 13.5 6.82843 13.5 6V1.5C13.5 0.671573 14.1716 0 15 0Z' />
        <path d='M21 0C21.8284 0 22.5 0.671573 22.5 1.5V6C22.5 6.82843 21.8284 7.5 21 7.5C20.1716 7.5 19.5 6.82843 19.5 6V1.5C19.5 0.671573 20.1716 0 21 0Z' />
      </svg>
    </span>
  );
}

export default CoffeeIcon;
